// import styled from 'styled-components';
import styled from "@emotion/styled";

export const TopBannerSection = styled.div`
	position: relative;

	.slick-slider {
		.slick-prev {
			left: 50%;
			margin-left: -600px;
			top: auto;
			bottom: 90px;
			z-index: 1000;
		}
		.slick-next {
			left: 50%;
			margin-left: -530px;
			top: auto;
			bottom: 90px;
			z-index: 1000;
		}
	}

	.current {
		position: absolute;
		bottom: 96px;
		left: 50%;
		margin-left: -450px;
		font-size: ${(props: any) => props.theme.fontSizes.xl};
		color: ${(props: any) => props.theme.colors.b.gr};
		z-index: 1000;
	}

	@media	(max-width: ${(props: any) => props.theme.breakpoints.sm}) {
		.slick-slider {
			.slick-prev {
				bottom: 24px;
				margin-left: -180px;
				width: 24px;
			}
			.slick-next {
				bottom: 24px;
				margin-left: -140px;
				width: 24px;
			}
		}

		.current {
			bottom: 36px;
			margin-left: -100px;
			font-size: ${(props: any) => props.theme.fontSizes.md};
		}
	}
`;

type WorkBannerSectionTypes = {
	active?: boolean;
};

export const WorkBannerSection = styled.div<WorkBannerSectionTypes>`
	.slick-slider {
		.slick-prev {
			left: 50%;
			margin-left: 530px;
			top: -100px;
		}
		.slick-next {
			left: 50%;
			margin-left: 600px;
			top: -100px;
		}
		.slick-slide {
			opacity: 0.25;
			&.slick-active {
				opacity: 1;
			}
		}
	}

	.item {
		&-text {
			display: none;
		}
		&:hover {
			.item-text {
				display: block;
			}
			.item-image {
				display: none;
			}
		}
	}

	@media	(max-width: ${(props: any) => props.theme.breakpoints.sm}) {
		.slick-slider {
			.slick-prev {
				top: -70px;
				margin-left: 120px;
				width: 24px;
			}
			.slick-next {
				top: -70px;
				margin-left: 160px;
				width: 24px;
			}
		}
	}
`;

export const WorkBannerSectionFull = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 24px 0;

	.item {
		&-text {
			display: none;
		}
		&:hover {
			.item-text {
				display: block;
			}
			.item-image {
				display: none;
			}
		}
	}
`;

type JoinBannerSectionTypes = {
	active?: boolean;
};

export const JoinBannerSection = styled.div<JoinBannerSectionTypes>`
	position: relative;

	.slick-slider {
		.slick-prev {
			left: 50%;
			margin-left: -600px;
			top: auto;
			bottom: 0;
		}
		.slick-next {
			left: 50%;
			margin-left: -530px;
			top: auto;
			bottom: 0;
		}
		.slick-slide {
			opacity: 0.25;
			position: relative;
			&.slick-active {
				opacity: 1;
			}

			.chakra-link {
				
			}
			.badge {
				position: absolute;
				top: 20px;
				right: 30px;
				padding: 6px;
			}
		}
	}
	.current {
		position: absolute;
		bottom: 8px;
		left: 50%;
		margin-left: -450px;
		font-size: ${(props: any) => props.theme.fontSizes.xl};
		color: ${(props: any) => props.theme.colors.b.bk};
	}

	@media	(max-width: ${(props: any) => props.theme.breakpoints.sm}) {
		.slick-slider {
			.slick-prev {
				top: -40px;
				margin-left: 60px;
				width: 24px;
			}
			.slick-next {
				top: -40px;
				margin-left: 100px;
				width: 24px;
			}
		}
		.current {
			bottom: auto;
			top: -50px;
			margin-left: 150px;
		}
	}
`;

type NewsSectionTypes = {
	active?: boolean;
};

export const NewsSection = styled.div<NewsSectionTypes>``;

export const MiddleBannerSection = styled.section`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	@media	(max-width: ${(props: any) => props.theme.breakpoints.sm}) { 
		display: block;
		margin: 0 auto;
		text-align: center;
		width: 90%;
		overflow: hidden;
		
		> div {
			width: 50%;
			float: left;
			box-sizing: border-box;
		}

		a {
			display: block;
			text-align: center;
			margin-bottom: 5px;
			img {
				width: 98%;
				margin: 0 auto;
				display: block;
				display: block;
				box-sizing: border-box;
			}
		}
	}
`;
